if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 750px)');
        this.menuDrawerMql = window.matchMedia('(max-width: 989px)');
        this.header = document.querySelector('.header-wrapper');
        this.isHiding = false;
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };
        this.overlay = this.querySelector('.country-selector__overlay');
        this.isCountrySelector = this.elements.panel?.classList.contains('country-selector');
        this.portalRoot = null;
        this.menuDrawer = null;
        this.menuDrawerToggle = null;
        this.menuDrawerSummary = null;

        this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
        this.onContainerKeyDown = this.onContainerKeyDown.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onPortalPointerUp = this.onPortalPointerUp.bind(this);
        this.openSelector = this.openSelector.bind(this);
        this.onItemClick = this.onItemClick.bind(this);

        this.addEventListener('keyup', this.onContainerKeyUp);
        this.addEventListener('keydown', this.onContainerKeyDown);
        this.addEventListener('focusout', this.onFocusOut);
        this.elements.button?.addEventListener('click', this.openSelector);

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', this.filterCountries.bind(this));
          this.elements.search.addEventListener('focus', this.onSearchFocus.bind(this));
          this.elements.search.addEventListener('blur', this.onSearchBlur.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', (event) => this.requestHide(event));
          this.elements.closeButton.addEventListener('pointerup', (event) => this.requestHide(event));
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', this.resetFilter.bind(this));
          this.elements.resetButton.addEventListener('mousedown', (event) => event.preventDefault());
        }

        if (this.overlay) {
          this.overlay.setAttribute('hidden', '');
          this.overlay.addEventListener('click', (event) => this.requestHide(event));
          this.overlay.addEventListener('pointerup', (event) => this.requestHide(event));
        }

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick));
      }

      isPanelOpen() {
        return (
          this.elements.button?.getAttribute('aria-expanded') === 'true' &&
          !this.elements.panel?.hasAttribute('hidden')
        );
      }

      requestHide(event) {
        event.preventDefault();
        event.stopPropagation();
        this.hidePanel();
      }

      hidePanel() {
        if (this.isHiding || this.elements.panel?.hasAttribute('hidden')) return;
        this.isHiding = true;

        this.elements.button?.setAttribute('aria-expanded', 'false');
        this.elements.panel.classList.remove('is-closing');
        this.overlay?.classList.remove('is-closing');

        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.setAttribute('aria-activedescendant', '');
        }

        this.elements.panel.setAttribute('hidden', '');
        if (this.overlay) this.overlay.setAttribute('hidden', '');

        (this.menuDrawer || document.querySelector('.menu-drawer'))?.classList.remove('country-selector-open');
        this.unbindPortalListeners();
        this.restorePortal();
        document.body.classList.remove('overflow-hidden-mobile');
        document.body.classList.remove('rh-country-selector-open');

        this.restoreMenuDrawerFocusTrap();

        this.menuDrawer = null;
        this.menuDrawerToggle = null;
        this.menuDrawerSummary = null;
        if (this.header) this.header.preventHide = false;
        this.isHiding = false;

        this.elements.button?.focus();
      }

      bindPortalListeners() {
        document.addEventListener('pointerup', this.onPortalPointerUp, true);
      }

      unbindPortalListeners() {
        document.removeEventListener('pointerup', this.onPortalPointerUp, true);
      }

      onPortalPointerUp(event) {
        if (!document.body.classList.contains('rh-country-selector-open')) return;

        const closeButton = event.target.closest('.country-selector__close-button');
        if (closeButton && this.elements.panel?.contains(closeButton)) {
          this.requestHide(event);
          return;
        }

        if (event.target === this.overlay) {
          this.requestHide(event);
        }
      }

      suspendMenuDrawerFocusTrap() {
        const headerDrawer = document.querySelector('header-drawer');
        if (!headerDrawer) return;

        this.menuDrawerToggle = headerDrawer.querySelector('details');
        this.menuDrawerSummary = headerDrawer.querySelector('summary');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus();
        }
      }

      restoreMenuDrawerFocusTrap() {
        if (
          !this.menuDrawerToggle?.hasAttribute('open') ||
          !this.menuDrawerSummary ||
          typeof trapFocus !== 'function'
        ) {
          return;
        }

        trapFocus(this.menuDrawerToggle, this.menuDrawerSummary);
      }

      portalPanel() {
        if (!this.isCountrySelector || !this.menuDrawerMql.matches) return;

        const menuDrawer = this.closest('.menu-drawer');
        if (!menuDrawer) return;

        this.menuDrawer = menuDrawer;
        this.portalRoot = this.elements.panel.parentElement;

        document.body.appendChild(this.elements.panel);
        if (this.overlay) {
          this.overlay.removeAttribute('hidden');
          document.body.appendChild(this.overlay);
        }

        document.body.classList.add('rh-country-selector-open');
        menuDrawer.classList.add('country-selector-open');
        this.suspendMenuDrawerFocusTrap();
        this.bindPortalListeners();

        const current = this.elements.panel.querySelector('[aria-current="true"]');
        if (current) {
          requestAnimationFrame(() => current.scrollIntoView({ block: 'center' }));
        }
      }

      restorePortal() {
        if (!this.portalRoot) return;

        if (this.overlay?.parentElement === document.body) {
          this.portalRoot.appendChild(this.overlay);
        }

        if (this.elements.panel.parentElement === document.body) {
          if (this.overlay?.parentElement === this.portalRoot) {
            this.portalRoot.insertBefore(this.elements.panel, this.overlay);
          } else {
            this.portalRoot.appendChild(this.elements.panel);
          }
        }

        this.portalRoot = null;
      }

      onContainerKeyDown(event) {
        const focusableItems = Array.from(this.querySelectorAll('a')).filter(
          (item) => !item.parentElement.classList.contains('hidden')
        );
        let focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
        let itemToFocus;

        switch (event.code.toUpperCase()) {
          case 'ARROWUP':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
            itemToFocus.focus();
            break;
          case 'ARROWDOWN':
            event.preventDefault();
            itemToFocus =
              focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
            itemToFocus.focus();
            break;
        }

        if (!this.elements.search) return;

        setTimeout(() => {
          focusedItemIndex = focusableItems.findIndex((item) => item === document.activeElement);
          if (focusedItemIndex > -1) {
            this.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
          } else {
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
        });
      }

      onContainerKeyUp(event) {
        event.preventDefault();

        switch (event.code.toUpperCase()) {
          case 'ESCAPE':
            if (!this.isPanelOpen()) return;
            this.hidePanel();
            event.stopPropagation();
            this.elements.button?.focus();
            break;
          case 'SPACE':
            if (this.isPanelOpen()) return;
            this.openSelector();
            break;
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        if (this.isPanelOpen()) {
          this.hidePanel();
          return;
        }

        this.elements.button?.focus();
        this.elements.panel.removeAttribute('hidden');
        this.elements.panel.classList.remove('is-closing');
        this.overlay?.classList.remove('is-closing');
        this.overlay?.removeAttribute('hidden');
        this.elements.button?.setAttribute('aria-expanded', 'true');

        if (!document.body.classList.contains('overflow-hidden-tablet')) {
          document.body.classList.add('overflow-hidden-mobile');
        }

        if (this.elements.search && this.mql.matches) {
          this.elements.search.focus();
        }

        if (this.hasAttribute('data-prevent-hide') && this.header) {
          this.header.preventHide = true;
        }

        this.portalPanel();
      }

      onFocusOut(event) {
        if (this.isHiding || !this.isPanelOpen()) return;
        if (document.body.classList.contains('rh-country-selector-open')) return;

        const scope = [this, this.elements.panel, this.overlay].filter(Boolean);
        const targetInside = scope.some((node) => node.contains(event.target));
        const relatedInside =
          !event.relatedTarget || scope.some((node) => node.contains(event.relatedTarget));

        if (!targetInside || !relatedInside) {
          this.hidePanel();
        }
      }

      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase();
      }

      filterCountries() {
        const searchValue = this.normalizeString(this.elements.search.value);
        const popularCountries = this.querySelector('.popular-countries');
        const allCountries = this.querySelectorAll('a');
        let visibleCountries = allCountries.length;

        if (this.elements.resetButton) {
          this.elements.resetButton.classList.toggle('hidden', !searchValue);
        }

        if (popularCountries) {
          popularCountries.classList.toggle('hidden', searchValue);
        }

        allCountries.forEach((item) => {
          const countryName = this.normalizeString(item.querySelector('.country').textContent);
          if (countryName.indexOf(searchValue) > -1) {
            item.parentElement.classList.remove('hidden');
            visibleCountries++;
          } else {
            item.parentElement.classList.add('hidden');
            visibleCountries--;
          }
        });

        if (this.elements.liveRegion) {
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace(
            '[count]',
            visibleCountries
          );
        }

        const panel = this.elements.panel?.classList.contains('country-selector')
          ? this.elements.panel
          : this.querySelector('.country-selector');
        const list = panel?.querySelector('.country-selector__list');
        if (panel) panel.scrollTop = 0;
        if (list) list.scrollTop = 0;
      }

      resetFilter(event) {
        event.stopPropagation();
        this.elements.search.value = '';
        this.filterCountries();
        this.elements.search.focus();
      }

      onSearchFocus() {
        this.elements.searchIcon?.classList.add('country-filter__search-icon--hidden');
      }

      onSearchBlur() {
        if (!this.elements.search.value) {
          this.elements.searchIcon?.classList.remove('country-filter__search-icon--hidden');
        }
      }

      onSearchKeyDown(event) {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
        }
      }
    }
  );
}
